<template>
    <div style="z-index: 999999">
        <div class="modal hide fade" id="modalInventoryForm" tabindex="0" role="dialog" aria-labelledby="modalInventoryForm" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Inventory - {{ inventory.inventory_no }}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <dl class="row dl-custom">
                                    <dt class="col-md-4">Date</dt>
                                    <dd class="col-md-8">{{ inventory.inventory_date | dateFormat('DD/MM/YYYY') }}</dd>
                                    <dt class="col-md-4">Type</dt>
                                    <dd class="col-md-8">{{ inventory.type_id }}</dd>
                                    <dt class="col-md-4">Invoice No</dt>
                                    <dd class="col-md-8">{{ inventory.ext_no }}</dd>
                                    <dt class="col-md-4">Warehouse</dt>
                                    <dd class="col-md-8">{{ inventory.warehouse }}</dd>
                                    <dt class="col-md-4">Company</dt>
                                    <dd class="col-md-8">{{ inventory.company }}</dd>
                                </dl>
                                <div class="table-responsive">
                                    <table class="table table-item table-sm table-hover table-striped">
                                        <thead>
                                            <th>Product</th>
                                            <th>Qty</th>
                                            <th>Uom</th>
                                            <th class="text-right">COGS</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="d in inventory.details" :key="d.i">
                                                <td><b>[{{ d.product_no }}]</b> {{ d.product }}</td>
                                                <td>{{ d.qty_done }}</td>
                                                <td>{{ d.uom_id }}</td>
                                                <td class="text-right">{{ d.cost | currency }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <!-- <pre>{{ inventory }}</pre> -->
                    </div>
                    <div class="modal-footer">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'InventoryFormModal',
  data () {
    return {
      idDetail: 1,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      inventory: state => state.inventories.inventory
    })
  },
  methods: {
  }
}
</script>
